<div class="d-flex flex-column gap-3"> 
    <app-page-divider [text]="'inbox.news.title' | transloco" [icon]="'fa-solid fa-newspaper'" />
    <app-news-list [displayEmptyInformation]="true" [displayLoadingIndicator]="true"></app-news-list>

    <app-page-divider [text]="'inbox.notifications.title' | transloco" [icon]="'fa-solid fa-bell'" />

    <app-notifications-list></app-notifications-list>
</div>
